export default "__VITE_ASSET__CDH3nTgy__"